import styled from "@emotion/styled";
import { PageLayout } from "../../shared/layouts/PageLayout";
import { adminDashboardBreadcrumbs } from "../../features/AdminDashboard/admin-dashboard-breadcrumbs";
import { useGetSubscriptionPlans } from "@queries/subscription-plans/useGetSubscriptionPlans";
import { SubscriptionPlansList } from "@features/SubscriptionPlans/SubscriptionPlansList";

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1.5rem;
  width: 100%;
  position: relative;

  ${(p) => p.theme.media.mobileDown} {
    grid-template-columns: 1fr;
  }

  &[aria-disabled="true"] {
    pointer-events: none;
    opacity: 0.5;
    * {
      pointer-events: none;
    }
  }
`;

const breadcrumbs = {
  current: adminDashboardBreadcrumbs.subscriptionPlans,
  previous: [adminDashboardBreadcrumbs.dashboard],
};

export function SubscriptionPlansPage() {
  const query = useGetSubscriptionPlans();

  return (
    <PageLayout breadcrumbs={breadcrumbs}>
      <Container aria-disabled={query.isLoading}>
        <SubscriptionPlansList
          subscriptionPlans={query.data?.items ?? []}
          isLoadingSubscriptionPlans={query.isLoading}
        />
      </Container>
    </PageLayout>
  );
}
